export default (props) => (
  /**
   * Exportação de feições de camadas internas (WMS)
   * para uma nova camada vetorial (Geojson)
   */  
  <svg
    width={19}
    height={20}
    viewBox="0 0 19 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle
      cx={2.31514}
      cy={10.3469}
      r={1.8}
      fill={props.fill ? props.fill : 'currentColor'}
    />
    <circle
      cx={8.31501}
      cy={17.3469}
      r={1.8}
      fill={props.fill ? props.fill : 'currentColor'} 
    />
    <circle
      cx={16.315}
      cy={12.1438}
      r={1.8}
      fill={props.fill ? props.fill : 'currentColor'} 
    />
    <path
      d="M9.1116 3.34687C9.1116 4.34099 8.30571 5.14687 7.3116 5.14687C6.31748 5.14687 5.5116 4.34099 5.5116 3.34687C5.5116 2.35276 6.31748 1.54688 7.3116 1.54688C8.30571 1.54688 9.1116 2.35276 9.1116 3.34687Z"
      fill={props.fill ? props.fill : 'currentColor'}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.84486 2.82135L7.21883 2.19531L6.70423 2.91575L1.70423 9.91575L1.36279 10.3938L1.74509 10.8398L7.74509 17.8398L8.16494 18.3296L8.71203 17.9877L16.712 12.9877L17.5115 12.488L16.8449 11.8213L14.7795 9.75603L13.6929 10.7907L15.1175 12.2154L8.46412 16.3737L3.26627 10.3096L7.41023 4.50804L8.95688 6.05469L10.0435 5.02003L7.84486 2.82135Z"
      fill={props.fill ? props.fill : 'currentColor'}
    />
    <path
      d="M16.1991 1.54792C16.4888 1.25826 17.0617 1.36149 17.4787 1.77851C17.8957 2.19552 17.9989 2.76839 17.7093 3.05806L11.0337 9.73368C10.744 10.0233 10.1711 9.92011 9.7541 9.5031C9.33709 9.08609 9.23386 8.51321 9.52352 8.22355L16.1991 1.54792Z"
      fill={props.fill ? props.fill : 'currentColor'}
    />
    <path
      d="M16.6236 2.63565L12.3523 2.63565C11.7625 2.63565 11.2844 2.15757 11.2844 1.56783C11.2844 0.978082 11.7625 0.5 12.3523 0.5L17.6914 0.500001C18.2811 0.500001 18.7592 0.978084 18.7592 1.56783L18.7592 6.90696C18.7592 7.49671 18.2811 7.97479 17.6914 7.97479C17.1016 7.97479 16.6236 7.49671 16.6236 6.90696L16.6236 2.63565Z"
      fill={props.fill ? props.fill : 'currentColor'}
    />
  </svg>
);
